import { Calculator, Input } from "./index"

function main() {
    // Define the variables
    const formula = [
        [
            "estimatif_projet",
            "0 + surface * 2508.16 + coef_project_type[project_type].estimatif_projet * project_surface + piscine * 35000 + mobilier_decoration * 500 + amenagement_paysage * 5000",
            "round",
        ],
        [
            "travaux",
            "0 + surface * 2133.33 + coef_project_type[project_type].travaux * project_surface + piscine * 35000 + mobilier_decoration * 500 + amenagement_paysage * 5000",
            "round",
        ],
        [
            "honoraires",
            "0 + surface * 371.11 + coef_project_type[project_type].honoraires * project_surface",
            "round",
        ],
        [
            "eco_participation",
            "0 + surface*3.71 + coef_project_type[project_type].eco_participation * project_surface",
            "round",
        ],
        [
            "planning_global",
            "14 + surface*0.03 + coef_project_type[project_type].planning_global * project_surface + secteur_abf * 3",
            "round",
        ],
        ["mission_conseil", "549", "round"],
        [
            "esquisses",
            "3315 + surface*28.5 + coef_project_type[project_type].esquisses * project_surface",
            "round",
        ],
        [
            "usages",
            "surface*33.6 + coef_project_type[project_type].usages * project_surface",
            "round",
        ],
        [
            "materialite",
            "surface*27 + coef_project_type[project_type].materialite * project_surface",
            "round",
        ],
        [
            "details",
            "surface*34.21 + coef_project_type[project_type].details * project_surface",
            "round",
        ],
        [
            "dossier",
            "surface * 16.1 + coef_project_type[project_type].dossier * project_surface",
            "round",
        ],
        [
            "mise_au_point",
            "surface * 13.8 + coef_project_type[project_type].mise_au_point * project_surface",
            "round",
        ],
        [
            "realisation",
            "surface * 92 + coef_project_type[project_type].realisation * project_surface",
            "round",
        ],
        [
            "travaux_artisans",
            "surface * 1710 + coef_project_type[project_type].travaux_artisans * project_surface + piscine * 35000 + mobilier_decoration * 10000 + amenagement_paysage * 5000",
            "round",
        ],
        [
            "eco_participation_bis",
            "surface * 3.71 + coef_project_type[project_type].eco_participation * project_surface + 3.89",
            "round",
        ],
        ["time-1", "0.5"],
        ["time-2", "1.5 + 0.01 * surface + 0.01 * project_surface"],
        ["time-3", "2.5"],
        ["time-4", "1.5 + 0.01 * surface + 0.01 * project_surface"],
        ["time-5", "8.0 + 0.009 * surface + 0.00143 * project_surface"],
    ]

    const variables = [
        new Input("surface", "#surface"),
        new Input("project_type", "#project_type"),
        new Input("project_surface", "#project_surface"),
        new Input("piscine", "#piscine"),
        new Input("mobilier_decoration", "#mobilier_decoration"),
        new Input("amenagement_paysage", "#amenagement_paysage"),
        new Input("secteur_abf", "#secteur_abf"),
        {
            name: "coef_project_type",
            value: {
                rafraichissement: {
                    estimatif_projet: 1332.3,
                    travaux: 920,
                    honoraires: 234,
                    eco_participation: 2.3,
                    planning_global: 0.02,
                    esquisses: 28.5,
                    usages: 18,
                    materialite: 13.5,
                    details: 16.5,
                    dossier: 10.5,
                    mise_au_point: 9,
                    realisation: 60,
                    travaux_artisans: 750,
                },
                renovation_legere: {
                    estimatif_projet: 1562.8,
                    travaux: 1150,
                    honoraires: 280,
                    eco_participation: 2.8,
                    planning_global: 0.03,
                    esquisses: 28.5,
                    usages: 21.6,
                    materialite: 16.2,
                    details: 19.8,
                    dossier: 12.6,
                    mise_au_point: 10.8,
                    realisation: 72,
                    travaux_artisans: 900,
                },
                renovation_interieure: {
                    estimatif_projet: 1744.81,
                    travaux: 1380,
                    honoraires: 281,
                    eco_participation: 2.81,
                    planning_global: 0.03,
                    esquisses: 28.5,
                    usages: 25.2,
                    materialite: 18.9,
                    details: 23.1,
                    dossier: 14.7,
                    mise_au_point: 12.6,
                    realisation: 84,
                    travaux_artisans: 1050,
                },
                renovation_complete: {
                    estimatif_projet: 1925.17,
                    travaux: 1560,
                    honoraires: 317,
                    eco_participation: 3.17,
                    planning_global: 0.03,
                    esquisses: 28.5,
                    usages: 27.6,
                    materialite: 20.7,
                    details: 25.3,
                    dossier: 16.1,
                    mise_au_point: 13.8,
                    realisation: 92,
                    travaux_artisans: 1200,
                },
                rehabilitation_lourde: {
                    estimatif_projet: 2105.53,
                    travaux: 1740,
                    honoraires: 353,
                    eco_participation: 3.53,
                    planning_global: 0.03,
                    esquisses: 28.5,
                    usages: 27.6,
                    materialite: 20.7,
                    details: 25.3,
                    dossier: 16.1,
                    mise_au_point: 13.8,
                    realisation: 92,
                    travaux_artisans: 1350,
                },
            },
        },
    ]

    const calculator = new Calculator(formula, variables)

    let result = calculator.compute()
    result.forEach((output) => setResult(...output))

    document.forms[0].addEventListener("change", () => {
        result = calculator.compute()
        result.forEach((output) => setResult(...output))
    })
}

function setResult(name, value) {
    document.getElementById(name).innerText = value.toLocaleString("en")
}

main()
